import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
    path: '/sw',
    name: 'sw',
    component: () => import('../views/sw.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/index.vue')
  },
    {
    path: '/logs',
    name: 'logs',
    component: () => import('../views/logs.vue')
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('../views/invite/index.vue')
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: () => import('../views/wallet/withdraw.vue')
  },
  {
    path: '/withdrawRecord',
    name: 'withdrawRecord',
    component: () => import('../views/wallet/withdrawRecord.vue')
  },
  {
    path: '/pledge',
    name: 'pledge',
    component: () => import('../views/pledge/index.vue')
  },
  {
    path: '/pledgeRecord',
    name: 'pledgeRecord',
    component: () => import('../views/pledge/pledgeRecord.vue')
  },
  {
    path: '/pool',
    name: 'pool',
    component: () => import('../views/pool/index.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user/index.vue')
  },
  {
    path: '/exchangeRecord',
    name: 'exchangeRecord',
    component: () => import('../views/wallet/exchangeRecord.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
